export default {"src":"/_next/static/media/personal-relations.c67ae07e.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};